<template>
  <div>
    <!-- Carrusel -->
    <section id="banners" data-aos="fade-up" data-aos-duration="1200">
      <div>
        <AppCarrusel :items="carruselItems" :selectedLang="selectedLang" />
      </div>
    </section>

    <!-- ¿Qué es FRENKEL? -->
    <section id="howIs" class="how-is-section" data-aos="fade-right" data-aos-duration="6000" data-aos-offset="200" data-aos-easing="ease-in-out">
      <h1 class="how-is-title" style="text-align: center;">{{ aboutContent.title }}</h1>
      <div class="video-container d-flex justify-content-center" >
        <video
          controls
          :src="aboutContent.video"
          class="how-is-video"
          :class="{ 'video-playing': isPlaying }"
          @play="isPlaying = true"
          @pause="isPlaying = false"
        />
      </div>
      <div class="how-is-section-btn">
        <router-link :to="aboutLink" class="how-is-button" @click="goToServicio()">
          {{ aboutContent.button }}
        </router-link>
      </div>
      
    </section>

    <!-- Servicios -->
    <section id="whatDoes" data-aos="fade-left" data-aos-duration="6000">
      <ServiceGrid :selectedLang="selectedLang" />
    </section>

    <!-- ¿Por qué Frenkel? -->
    <section id="whyUs" data-aos="zoom-in" data-aos-duration="6000">
      <WhyFrenkel :selectedLang="selectedLang" />
    </section>

    <!-- Entrenamiento -->
    <section id="training" data-aos="fade-up" data-aos-duration="6000">
      <TrainingSection :selectedLang="selectedLang" />
    </section>

    <!-- Últimas noticias -->
    <section id="latestNews" data-aos="fade-up" data-aos-duration="6000">
      <LatestNews :selectedLang="selectedLang"/>
    </section>

    <!-- Contacto -->
    <section id="contactForm"  data-aos="fade-up" data-aos-duration="6000">
      <ContactFrom :selectedLang="selectedLang"/>
    </section>

    <SiteFooter :selectedLang="selectedLang" />
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import { carruselItems, aboutSection } from '@/assets/data/data.ts';

import AppCarrusel from '@/components/AppCarrusel.vue';
import ServiceGrid from '@/components/ServiceGrid.vue';
import WhyFrenkel from '@/components/WhyFrenkel.vue';
import TrainingSection from '@/components/TrainingSection.vue';
import LatestNews from '@/components/blog/LatestNews.vue';
import ContactFrom from '@/components/ContactFrom.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import { onMounted } from 'vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

onMounted(() => {
  AOS.init({
    duration: 800,
    once: true 
  })
  setTimeout(() => AOS.refresh(), 300)
})


export default {
  name: 'InicioPage',
  props: {
    selectedLang: {
      type: String,
      required: true
    }
  },
  setup() {
    useSEO({
      description: 'Frenkel Engineering impulsa tu transformación digital con soluciones de Industria 4.0, automatización, consultoría y capacitación industrial.',
      path: '/',
    });
  },
  methods: {
    goToServicio() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
  components: {
    AppCarrusel,
    ServiceGrid,
    WhyFrenkel,
    TrainingSection,
    LatestNews,
    ContactFrom,
    SiteFooter
  },
  data() {
    return {
      carruselItems,
      isPlaying: false
    };
  },
  computed: {
    aboutContent() {
      return aboutSection[this.selectedLang] || aboutSection.es;
    },
    aboutLink() {
      return aboutSection.link;
    }
  },
  mounted() {
    AOS.init({
      duration: 800,
      once: true
    });

    setTimeout(() => AOS.refresh(), 300);
  }
};
</script>

<style scoped>
#contactForm{
 background-color: blue;
}
h1 {
  text-align: justify;
  margin-top: 20px;
}

.how-is-section {
  text-align: justify;
  margin: 40px auto;
}

.how-is-section-btn{
  text-align: center !important;
}

.how-is-title {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2rem;
  margin-bottom: 20px;
}

.video-container {
  padding: 10px;
  margin-bottom: 20px;
}

.how-is-video {
  width: 100%;
  max-width: 60%;
  height: auto;
}

.how-is-button {
  display: inline-block;
  background-color: black;
  color: white;
  padding: 0.4rem 1.2rem;
  border-radius: 999px;
  font-family: 'Caveat-Bold', cursive;
  text-decoration: none;
  font-size: 1rem;
}

.how-is-button {
  display: inline-block;
  padding: 0.5rem 1.2rem;
  background-color: #000;
  color: #fff;
  text-decoration: none;
  border-radius: 30px;
  font-family: 'Caveat-Bold', cursive;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}

.how-is-button:hover {
  background-color: #2c74b8; 
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); 
  cursor: pointer;
  color: #ffffff
}
.d-block.w-100 {
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.d-block.w-100:hover {
  transform: scale(1.05); 
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3); 
  cursor: pointer;
}

.how-is-video {
  width: 100%;
  max-width: 60%;
  height: auto;
  border: 2px solid transparent;
  transition: border 0.4s ease, transform 0.4s ease, box-shadow 0.4s ease;
  border-radius: 10px;
}

.how-is-video.video-playing {
  border-color: #2c74b8;
  transform: translateY(-5px);
  box-shadow: 0 0 20px #2c74b8;
}
</style>
